import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useDeletePasskeyMutation } from '../../queries';

export const useDeletePasskeyConfirmModal = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deletePasskey } = useDeletePasskeyMutation();

  const confirm = useCallback(
    ({ passkeyId, passkeyName }: { passkeyId: string; passkeyName: string }) => {
      const handleDeletePasskey = async () => {
        await deletePasskey(
          { passkeyId },
          {
            onError() {
              message.error("Something went wrong. The passkey couldn't be deleted.");
            },
            onSuccess() {
              message.success('Passkey deleted successfully.');
            },
          },
        );
      };

      modal.confirm({
        content: 'Deleting this passkey means you’ll need to login differently next time.',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Delete',
        onOk: handleDeletePasskey,
        title: t('Delete the passkey', { name: passkeyName }),
        type: 'error',
      });
    },
    [deletePasskey, modal, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
